import { number, shape, string } from 'prop-types'

export const mappedListAndRetailPriceType = {
  amount: number.isRequired,
  net: number.isRequired,
  currency: string.isRequired,
  type: string.isRequired,
  formatted: string.isRequired,
}

export const pricesShapeType = shape(mappedListAndRetailPriceType)
